import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import FollowUs from "../Footer/FollowUs";
import LetsGet from "../Footer/LetsGet";
import Carousel from "../ThreeD/Carousel";
import CountUp from "react-countup";

  const ThreeD = () => {
    
  const [mouse, setMouse] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left - rect.width / 2) / 40;
    const y = (e.clientY - rect.top - rect.height / 2) / 40;
    setMouse({ x, y });
  };

const testimonials = [
  {
    text: "At Open Studios, we believe that every great idea deserves the perfect platform to thrive. As a team of passionate creatives, tech enthusiasts, and strategic thinkers, we are dedicated to transforming your vision into reality.",
    name: "Mark Rodriguez",
    role: "Real Estate Developer, Horizon Properties",
  },
  {
    text: "Working with Open Studios was a game-changer for our brand. Their creativity, precision, and technical excellence exceeded our expectations.",
    name: "Sarah Thompson",
    role: "Marketing Director, Elevate Corp",
  },
  {
    text: "The team truly understands design and strategy. They delivered a digital experience that perfectly reflects our vision.",
    name: "Daniel Wu",
    role: "Founder, NeoTech Solutions",
  },
];
// ]; 

  const xStep = 160;  
  const yStep = 28;    
  const scaleStep = 0.03;
  const rotateStep = -4;
  const opacityStep = 0.1;

//  desktop
  const cards = [
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/b24f2225-ee94-46bf-82ef-0206c2207e00/public", //op_3D_TD01.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e9de6fdc-e563-46b9-b6a5-11d608fb2500/public", //op_3D_TD04.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/12471cef-124d-4f8a-9905-c6de7e9eed00/public", //op_3D_TD03.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/ff97a8e6-f913-4d85-d266-03ab6c20c600/public", //op_3D_TD02.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/9ac1e4c7-4c53-4d00-1ff5-52916ba17c00/public", //op_3D_TD05.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/99047f01-eaeb-4468-b0ae-ac713b4acc00/public", //op_3D_TD06.webp
      "https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/7da6de56-3ace-4508-423d-b1b8bbc47a00/public", //op_3D_TD07.webp
  ];

  //testimonial//
  const [current, setCurrent] = useState(0);
  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };
  //end

  //animation
  const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1,
      ease: "easeOut",
    },
  },
};

const fadeLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1, ease: "easeOut" },
  },
};

const fadeRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1, ease: "easeOut" },
  },
};

//number
const sectionRef = useRef(null);
const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run only once
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  //img 

  const imgRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target); // animate only once
        }
      },
      { threshold: 0.3 }
    );

    if (imgRef.current) observer.observe(imgRef.current);

    return () => observer.disconnect();
  }, []);


  return (
    // <div>
    <div className="overflow-x-hidden">
      <Header />
    <div className="bg-white flex flex-col sm:px-10 lg:px-24 xl:px-32 2xl:px-40">
     
      <div className="container mx-auto md:px-0 px-3
          flex flex-col lg:flex-row justify-start h-full pt-20 lg:pt-8">

        <motion.div
                    variants={fadeLeft}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="oswald w-full lg:w-1/2 font-semibold lg:mt-24 xl:mt-12 
            text-[35px] sm:text-[52px] lg:text-[55px] xl:text-[75px]"
                  >
        {/* <div className="oswald w-full lg:w-1/2 font-semibold lg:mt-24 xl:mt-12 
            text-[35px] sm:text-[52px] lg:text-[55px] xl:text-[75px]"> */}
          <h2 className="text-[#908583]">MEET&nbsp;PCA</h2>
          <h1 className="text-[#000000] leading-tight">
            WHERE&nbsp;ART&nbsp;MEETS<br />INNOVATION
          </h1>
        {/* </div> */}
        </motion.div>

        <motion.div
                    variants={fadeRight}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="w-full sm:w-1/2 flex flex-col items-end mt-0 
                    lg:mt-28 xl:mt-20 sm:ml-[43vw] lg:ml-0 xl:ml-0"
        >
        {/* <div className="w-full sm:w-1/2 flex flex-col items-end mt-0 
            lg:mt-28 xl:mt-20 sm:ml-[43vw] lg:ml-0 xl:ml-0"> */}

          <div className="relative xl:w-36 xl:h-36 w-28 h-28">
            
            <div className=" absolute inset-0 rounded-full bg-[#ED772F]"></div>

            <svg
              viewBox="0 0 300 300"
              className="absolute inset-0 w-full h-full"
            >
              <defs>
                <path
                  id="circlePath"
                  d="M 150, 150
                    m -110, 0
                    a 110,110 0 1,1 220,0
                    a 110,110 0 1,1 -220,0"
                />
              </defs>

              <text
                fontSize="28"
                fontWeight="s00"
                fill="#000000"
                letterSpacing="4"
              >
                <textPath
                  href="#circlePath"
                  startOffset="50%"
                  textAnchor="middle"
                  fontFamily="oswald"
                >
                  OPEN - STUDIOS - 3D - VISUALIZATION -
                </textPath>
              </text>
            </svg>

            <div className="absolute inset-0 flex items-center justify-center">
              <img
                src="../assets/PCA_logo.png"
                alt="Logo"
                className="w-10 h-auto object-contain"
              />
            </div>
            
          </div>

          <div className="oswald mt-9 text-right font-medium xl:text-[28px] text-[20px]">
            <h2 className="text-[#000000]">BASED&nbsp;IN&nbsp;RAJKOT,&nbsp;GUJARAT</h2>
            <h2 className="text-[#908583]">WORKING&nbsp;WORLDWIDE</h2>
          </div>
        {/* </div> */}
        </motion.div>
      </div>

      <hr className="border-t-2 border-[#908583] w-[97%] mx-auto mt-1" />

      {/* Description */}
      <div className="grid grid-cols-12 items-center py-7">
        <div className="hidden sm:flex justify-center items-center text-[#908583] text-[18px] gap-3 col-span-1">
            <span>↓</span>
            <span>↓</span>
            <span>↓</span>
        </div>

        <div
         className="bodyFont col-span-12 sm:col-span-11 flex justify-end text-left sm:text-right text-[#1A1919] text-[18px]">
            <p className="xl:w-[850px] lg:w-[65%] md:w-[65%] w-[95%]">
                At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
                As a team of passionate creatives, tech enthusiasts, and strategic thinkers,
                we are dedicated to transforming your vision into reality.
            </p>
        </div>
      </div>

      {/* Mobile */}
      <Carousel /> 
      
      {/* desktop */}
      <div
        className="hidden lg:block px-10 py-10 mt-10
                    mx-[calc(50%-49.5vw)] overflow-hidden"
        onMouseMove={handleMouseMove}
        onMouseLeave={() => setMouse({ x: 0, y: 0 })}
      >
        <div
          className="relative h-[450px] flex justify-center items-start
                    pl-10 mx-auto max-w-[1200px] lg:max-w-[1100px] xl:max-w-[1300px] 2xl:max-w-[1500px]"
          style={{ perspective: "1600px" }}
        >
          {cards.map((src, i) => {
            const zIndexValue = cards.length - i;

            return (
              <motion.div
                key={i}
                className="absolute w-[420px] h-[300px] overflow-hidden shadow-xl bg-white"
                style={{ zIndex: zIndexValue, left: 0 }}
                initial={{
                  x: xStep * i,
                  y: yStep * i,
                  scale: 1 - i * scaleStep,
                  rotateY: rotateStep * i,
                  opacity: 1 - i * opacityStep,
                }}
                animate={{
                  rotateX: mouse.y,
                  rotateY: mouse.x + rotateStep * i,
                }}
                whileHover={{
                  y: yStep * i - 20,
                  scale: 1.15,
                  rotateY: 0,
                  rotateX: 0,
                  zIndex: 9999,
                  opacity: 1,
                  boxShadow: "0 30px 50px rgba(0,0,0,0.25)"
                }}
                transition={{ type: "spring", stiffness: 120, damping: 16 }}
              >
                <img src={src} className="w-full h-full object-cover" alt={`card-${i}`} />
              </motion.div>
            );
          })}
        </div>
      </div>
        
        <div className="w-full px-4 sm:px-8 lg:px-16 xl:px-20 py-5">
          <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen gap-10">

            {/* <div className="relative h-[60vh] lg:h-screen overflow-hidden"> */}
            <motion.div
                        variants={fadeLeft}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="relative h-[60vh] lg:h-screen overflow-hidden">
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/c6e92838-603f-419d-9bdf-acc599d2c800/public" //op_3D_01.webp
                alt="Visualization Team"
                className="w-full h-[86vh] object-cover object-center"
              />
              </motion.div>
            {/* </div> */}

            <div className="flex flex-col justify-center h-full lg:pl-10 lg:border-l lg:border-[#908583]">

              <div className="mb-10">
                <h2 className="oswald text-3xl sm:text-4xl xl:text-5xl font-extrabold leading-tight uppercase text-black">
                  Pioneering&nbsp;the&nbsp;Future<br className="hidden xl:block"/>{" "}
                  of 3D Architectural<br className="hidden xl:block"/>{" "}
                  Visualization
                </h2>

                <p className="bodyFont text-sm sm:text-base text-[#1A1919] max-w-md mt-8">
                  At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
                  As a team of passionate creatives, tech enthusiasts, and strategic thinkers,
                  we are dedicated to transforming your vision into reality.
                </p>
              </div>

              {/* <div className="grid grid-cols-2 gap-4 mb-10">
                <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                  <h1 className="oswald text-[48px]">10+</h1>
                  <p className="inter text-sm">Years of experience</p>
                </div>

                <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                  <h1 className="oswald text-[48px]">88+</h1>
                  <p className="inter text-sm">Projects Completed</p>
                </div>

                <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                  <h1 className="oswald text-[48px]">5000+</h1>
                  <p className="inter text-sm">Visualizations Created</p>
                </div>

                <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                  <h1 className="oswald text-[48px]">5</h1>
                  <p className="inter text-sm">Industry Awards</p>
                </div>
              </div> */}
              <div ref={sectionRef} className="grid grid-cols-2 gap-4 mb-10">
      
              <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                <h1 className="oswald text-[48px]">
                  {isVisible && <CountUp end={10} suffix="+" duration={2.5} />}
                </h1>
                <p className="inter text-sm">Years of experience</p>
              </div>

              <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                <h1 className="oswald text-[48px]">
                  {isVisible && <CountUp end={88} suffix="+" duration={2.5} />}
                </h1>
                <p className="inter text-sm">Projects Completed</p>
              </div>

              <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                <h1 className="oswald md:text-[48px] text-[40px]">
                  {isVisible && <CountUp end={5000} suffix="+" duration={3} />}
                </h1>
                <p className="inter text-sm">Visualizations Created</p>
              </div>

              <div className="bg-[#F56E0F] rounded-md p-4 text-black">
                <h1 className="oswald text-[48px]">
                  {isVisible && <CountUp end={5} duration={2} />}
                </h1>
                <p className="inter text-sm">Industry Awards</p>
              </div>

            </div>

              <div className="pt-6 border-t border-[#908583]">
              {/* <motion.div
                          variants={fadeRight}
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true }}
                          className="pt-6 border-t border-[#908583]"> */}
                <h2 className="oswald text-3xl sm:text-4xl font-semibold uppercase text-black">
                  The Heart of PCA
                </h2>

                <p className="bodyFont text-sm sm:text-base text-[#1A1919] max-w-md mt-4">
                  At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
                  As a team of passionate creatives, tech enthusiasts, and strategic thinkers,
                  we are dedicated to transforming your vision into reality.
                </p>
              </div>
               {/* </motion.div>    */}
            </div>
          </div>
        </div>

        <hr className="border-0 lg:border-t lg:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-2" />

        <div className="w-full text-center py-16 px-4 sm:px-8 md:px-20 lg:px-32">
          <h3 className="oswald text-[20px] font-medium text-[#908583] uppercase">
            Our Approach
          </h3>

          <div>
          <h1 className="oswald text-black font-semibold uppercase leading-tight 2xl:text-[75px] xl:text-[70px] lg:text-[40px] sm:text-[35px] text-[20px]
                mt-3">
                Understanding&nbsp;Your&nbsp;Needs,<br />
                Delivering&nbsp;<span className="inline-block ml-3 xl:mb-7 align-middle">
                  <img
                    src="/assets/bulb.png" 
                    alt="Idea Bulb"
                    className="inline-block sm:w-auto w-[70px] sm:h-[55px] object-cover"
                  />
                </span> <br />
                Superior&nbsp;Outcomes
          </h1>
          </div>

          <p className="bodyFont text-[#1A1919] text-[18px] max-w-[750px] mx-auto mt-5 leading-relaxed">
            At Open Studios, we believe that every great idea deserves the perfect platform to thrive. 
            As a team of passionate creatives, tech enthusiasts, and strategic thinkers, 
            we are dedicated to transforming your vision into reality.
          </p>

          <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}>      
          <button className="inter mt-8 bg-[#F56E0F] text-[#1A1919] font-semibold px-6 py-3 rounded-full 
          text-sm sm:text-base hover:bg-[#ed772f] transition-all duration-300 flex items-center mx-auto gap-2">
            <span>●</span> LET'S TALK
          </button>
        </motion.div>
        </div>

      <div className="full-slider">
  <div className="slide-track">
    {Array.from({ length: 20 }).map((_, i) => (
      <React.Fragment key={i}>
        <div className="slide-item">
          <span className="slide-text oswald">WORK WITH US</span>
        </div>
        <div className="slide-item">
          <img 
            src="../assets/PCA_logo.png" 
            alt="divider" 
            className="slide-img" 
          />
        </div>
      </React.Fragment>
    ))}
  </div>

  <style>{`
    .full-slider {
      position: relative;
      width: 100vw;
      left: 50%;
      right: 50%;
      margin-left: -50vw;
      height: 120px;
      overflow: hidden;
      background: white;
      display: flex;
      align-items: center;
    }

    /* Edge Fades */
    .full-slider::before,
    .full-slider::after {
      content: "";
      position: absolute;
      top: 0;
      width: 150px;
      height: 100%;
      z-index: 2;
      pointer-events: none;
      background: linear-gradient(to right, white, rgba(255,255,255,0));
    }
    .full-slider::after {
      right: 0;
      transform: rotate(180deg);
    }

    .slide-track {
      display: flex;
      align-items: center;
      width: max-content;
      /* Adjust time (40s) for speed */
      animation: scroll 40s linear infinite;
    }

    .slide-item {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 40px; /* This controls the "center" distance between items */
      white-space: nowrap;
      flex-shrink: 0;
    }

    .slide-text {
      font-weight: 700;
      font-size: 34px;
      transition: transform 0.3s ease;
    }

    .slide-img {
      height: 45px; /* Adjust based on your logo/icon size */
      width: auto;
      display: block;
    }

    /* Hover effect only on text */
    .slide-item:hover .slide-text {
      transform: scale(1.1);
      cursor: pointer;
    }

    @keyframes scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(-50%); }
    }

    @media (max-width: 768px) {
      .slide-text { font-size: 22px; }
      .slide-item { padding: 0 25px; }
      .slide-img { height: 30px; }
    }
  `}</style>
</div>

      <div className="bg-[#F4F1EF] px-4 sm:px-8 lg:px-32 py-10 mt-10 mx-[calc(50%-49.5vw)]">

        <h3 className="oswald text-[20px] font-medium text-[#908583] uppercase text-center">
            Our Values
        </h3>

        <h1 className="oswald text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-[#000000] mb-12">
          WHERE CREATIVITY MEETS<br />PRECISION AND CONNECTION
        </h1>

        <div className="flex justify-center mb-12 overflow-hidden">
        <img
          ref={imgRef}
          src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/4748ba34-cdf9-4f46-06e5-cf9e83038100/public"// op_3D_03.webp
          alt="Visualization Team"
          className={`h-[400px] w-auto object-cover transition-all duration-1000 ease-out
            ${visible ? "scale-100 opacity-100" : "scale-75 opacity-0"}
          `}
        />
        </div>

        {/* <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-left mb-12 text-[#000000]"> */}
        <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-left mb-12 text-[#000000]"
        >
          <div>
            <h2 className="oswald text-[30px] font-bold mb-2">CREATIVITY</h2>
            <p className="text-[16px] inter">
              We harness imaginative thinking to produce visually stunning and original 3D representations that captivate and inspire.
            </p>
          </div>
          <div>
            <h2 className="oswald text-[30px] font-bold mb-2">EXCELLENCE</h2>
            <p className="text-[16px] inter">
              We commit to the highest standards of quality and precision, ensuring every project meets our rigorous benchmarks of excellence.
            </p>
          </div>
          <div>
            <h2 className="oswald text-[30px] font-bold mb-2">ADAPTABILITY</h2>
            <p className="text-[16px] inter">
              We stay agile and responsive to evolving trends and client needs, constantly refining our approach to deliver cutting-edge results.
            </p>
          </div>
          <div>
            <h2 className="oswald text-[30px] font-bold mb-2">EMPATHY</h2>
            <p className="text-[16px] inter">
              We connect deeply with our clients and their audiences, crafting visuals that resonate with authenticity and emotional impact.
            </p>
          </div>
        {/* </div> */}
        </motion.div>

        <hr className="border-0 sm:border-t sm:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-2" />

        <div>   
          <div className="flex flex-col lg:flex-row items-start justify-between gap-6 mt-8">
            
            <h1 className="oswald text-3xl sm:text-4xl lg:text-5xl font-bold text-[#000000] lg:w-1/2">
              CLIENTS
            </h1>

            <p className="text-[16px] inter lg:w-1/2">
              At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
              As a team of passionate creatives, tech enthusiasts, and strategic thinkers, we are dedicated
              to transforming your vision into reality.
            </p>
          </div>

          <div className="w-auto overflow-hidden whitespace-nowrap py-10 mt-5">
            {/* <style>
              {`
                .logo-slide {
                  display: inline-flex;
                  gap: 60px;
                  animation: scrollLogos 12s linear infinite;
                }
                @keyframes scrollLogos {
                  0% { transform: translateX(0); }
                  100% { transform: translateX(-50%); }
                }
              `}
            </style>

            <div className="logo-slide">
              {[
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
              ].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt="img"
                  className="h-12 hover:scale-110 transition duration-300 ease-in-out"
                />
              ))}
            </div> */}
             <style>{`
            .slider {
              height: 70px;
              overflow: hidden;
              position: relative;
              width: 100%;
            }

            .slider::before,
            .slider::after {
              content: "";
              position: absolute;
              top: 0;
              width: 200px;
              height: 100%;
              z-index: 2;
              pointer-events: none;
            }

            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-250px * 7));
              }
            }

            .slide-track {
              display: flex;
              width: calc(250px * 14);
              animation: scroll 40s linear infinite;
            }

            .slide {
              width: 250px;
              height: 100px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .slide img {
              height: 48px;
              transition: transform 0.3s ease;
            }

            .slide img:hover {
              transform: scale(1.1);
            }
          `}</style>

          {/* JSX */}
          <div className="slider">
            <div className="slide-track">
              {[
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",

                // duplicate for seamless loop
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
                "/assets/openV_logo1.png",
              ].map((src, i) => (
                <div className="slide" key={i}>
                  <img src={src} alt="logo" />
                </div>
              ))}
            </div>
          </div>
            
          </div>
        </div>

        <hr className="border-0 sm:border-t sm:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-2" />

        <div className="flex flex-col lg:flex-row items-start justify-between gap-6 mt-8">
  
        
        <h1 className="oswald text-2xl sm:text-4xl lg:text-5xl font-bold text-[#000000] lg:w-1/2 uppercase">
          Crafting Visualization <br /> for industry leaders
        </h1>

        <div className="flex flex-col lg:w-[300px] lg:border-l lg:border-[#908583] lg:mr-5 lg:px-5">
          <p className="text-[16px] inter">
            At Open Studios, we believe that every great idea deserves the perfect platform to thrive. 
            As a team of passionate creatives, tech enthusiasts, and strategic thinkers, 
            we are dedicated to transforming your vision into reality.
          </p>

          <button className="mt-6 bg-[#F56E0F] text-[#1A1919] font-semibold px-6 py-3 rounded-full inter
            text-sm sm:text-base hover:bg-[#ed772f] transition-all duration-300 flex items-center w-fit gap-2">
            OUR SOLUTIONS
          </button>
        </div>
      </div>

      <hr className="border-0 sm:border-t sm:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-5" />

        <div className="flex flex-col lg:flex-row items-center justify-between gap-5 mt-10 mb-10 w-full xl:pl-12 pl-0">

        <div className="lg:w-auto lg:border-r lg:border-[#908583] pr-0 lg:pr-12 order-2 lg:order-1 w-full">
          <h2 className="oswald text-3xl sm:text-4xl lg:text-5xl font-bold text-[#000000] leading-snug lg:mb-20 mb-6 uppercase">
            Elevate Your <br className="hidden lg:block"/>Designs with <br className="hidden sm:block"/>Stunning 3D <br className="hidden lg:block"/>Visualization
          </h2>

          <p className="text-[16px] inter text-[#000000] max-w-full lg:w-[300px]">
            At Open Studios, we believe that every great idea deserves the perfect platform to thrive. As a team of 
          </p>
        </div>

        {/* <div className="flex justify-around lg:justify-around 2xl:justify-end w-full order-1 lg:order-2"> */}
        <motion.div
                    variants={fadeRight}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    className="flex justify-around lg:justify-around 2xl:justify-end w-full order-1 lg:order-2"
        >
          <img
            src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/2e0f15d1-27e4-41e7-3fcf-c4297d984500/public" //op_3D_02.webp
            alt="Creative Vision"
            className="sm:h-[400px] w-auto object-cover shadow-lg"
          />
          </motion.div>
        {/* </div> */}

      </div>
      </div>

        <div className="flex flex-col lg:flex-row items-start justify-between gap-6 mt-16 px-4 sm:px-8 lg:px-14">

          <h1 className="oswald text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#000000] uppercase lg:w-1/2 leading-tight">
            Showcasing <br />Our Expertise
          </h1>

          <div className="flex flex-col lg:w-1/2 lg:px-6">
            
            <p className="text-[16px] inter text-[#1A1919] xl:w-[600px]">
              At Open Studios, we believe that every great idea deserves the perfect platform to thrive. As a team of passionate creatives, tech enthusiasts, and 
            </p>

            <button className="mt-6 bg-[#F56E0F] text-[#1A1919] font-semibold px-6 py-3 rounded-full inter
              text-sm sm:text-base hover:bg-[#ed772f] transition-all duration-300 flex items-center w-fit gap-2 uppercase">
              our work
            </button>
          </div>
        </div>

        <hr className="border-t-2 border-[#908583] w-[90%] sm:w-[81vw] lg:w-[70vw] xl:w-[75vw] 2xl:w-[92%] mx-auto mt-8" />

        <div className="px-4 sm:px-8 lg:px-14 py-8 relative">
        {/* <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                > */}

          <div className="hidden md:block absolute top-3 bottom-3 left-1/2 border-r border-[#908583]"></div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 lg:gap-x-20 relative">

            {/* Card 1 */}
            <div className="w-full flex flex-col">
              {/* <div className="overflow-hidden">
                <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
              </div> */}
              <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/d4bba141-c513-4b99-580f-16cfb5319200/public" //op_3D_12.webp
                alt="Eco Haven"
                className="w-full h-full object-cover transition duration-500"
              /></motion.div>
              <div className="pt-4 mt-4">
                <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
                <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
                  <div>
                    <span className="oswald text-[#908583] font-semibold">SERVICES</span>
                    <p className="inter font-medium">Exterior + Interior</p>
                  </div>
                  <div>
                    <span className="oswald text-[#908583] font-semibold">LOCATION</span>
                    <p className="inter font-medium">Aspen, USA</p>
                  </div>
                </div>
              </div>
              <hr className="hidden md:block border-t border-[#908583] mt-6"/>
            </div>

            {/* Card 2 */}
            <div className="w-full flex flex-col">
              {/* <div className="overflow-hidden">
                <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
              </div> */}
              <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/e0bad4c3-a180-490e-feed-b9c4410fd800/public" //op_3D_09.webp
                alt="Eco Haven"
                className="w-full h-full object-cover transition duration-500"
              /></motion.div>
              <div className="pt-4 mt-4">
                <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
                <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
                  <div>
                    <span className="oswald text-[#908583] font-semibold">SERVICES</span>
                    <p className="inter font-medium">Exterior + Interior</p>
                  </div>
                  <div>
                    <span className="oswald text-[#908583] font-semibold">LOCATION</span>
                    <p className="inter font-medium">Aspen, USA</p>
                  </div>
                </div>
              </div>
              <hr className="hidden md:block border-t border-[#908583] mt-6"/>
            </div>

            {/* Card 3 */}
            <div className="w-full flex flex-col">
              {/* <div className="overflow-hidden">
                <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
              </div> */}
              <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
              <img
                 src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/29fe71a2-bddd-428f-75de-ecdff2b06f00/public" //op_3D_06.webp
                alt="Eco Haven"
                className="w-full h-full object-cover transition duration-500"
              /></motion.div>
              <div className="pt-4 mt-4">
                <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
                <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
                  <div>
                    <span className="oswald text-[#908583] font-semibold">SERVICES</span>
                    <p className="inter font-medium">Exterior + Interior</p>
                  </div>
                  <div>
                    <span className="oswald text-[#908583] font-semibold">LOCATION</span>
                    <p className="inter font-medium">Aspen, USA</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Card 4 */}
            <div className="w-full flex flex-col">
              {/* <div className="overflow-hidden">
                <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
              </div> */}
               <motion.div
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                >
              <img
                src="https://imagedelivery.net/JqAydcRLXyliJTMOjPllJQ/cd2e2faf-efa5-43f0-d0e4-61c0b2fbd800/public" //op_3D_07.webp
                alt="Eco Haven"
                className="w-full h-full object-cover transition duration-500"
              /></motion.div>
              <div className="pt-4 mt-4">
                <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
                <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
                  <div>
                    <span className="oswald text-[#908583] font-semibold">SERVICES</span>
                    <p className="inter font-medium">Exterior + Interior</p>
                  </div>
                  <div>
                    <span className="oswald text-[#908583] font-semibold">LOCATION</span>
                    <p className="inter font-medium">Aspen, USA</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <hr className="border-t-2 border-[#908583] w-[90%] sm:w-[81vw] lg:w-[70vw] xl:w-[75vw] 2xl:w-[92%] mx-auto mb-5" />

      <div className="bg-white w-full flex flex-col lg:flex-row justify-between items-center py-20 px-6 sm:px-12 lg:px-28">
      
      {/* <div className="flex flex-col justify-between h-full lg:w-1/3 sm:mr-40"> */}
      <motion.div
                  variants={fadeLeft}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  className="flex flex-col justify-between h-full lg:w-1/3 sm:mr-40"
                >
        <h3 className="oswald text-[14px] sm:text-[16px] text-[#000000] uppercase">
          Real Experiences - Real Impact
        </h3>

        <div className="flex gap-3 mt-20">
          <button
            onClick={prevSlide}
            className="w-10 h-10 rounded-full bg-[#FAC79F] flex items-center justify-center text-white text-xl hover:opacity-90 cursor-pointer"
          >
            <HiArrowLeft />
          </button>

          <button
            onClick={nextSlide}
            className="w-10 h-10 rounded-full bg-[#F27116] flex items-center justify-center text-white text-xl hover:opacity-90 cursor-pointer"
          >
            <HiArrowRight />
          </button>
        </div>
        </motion.div>
      {/* </div> */}

      {/* <div className="lg:w-2/3 mt-8 lg:mt-0 text-left ml-20"> */}
      <motion.div
                  variants={fadeRight}
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  className="lg:w-2/3 mt-8 lg:mt-0 text-left ml-20"
                >
        <p className="bodyFont text-[#1A1919] text-[18px] leading-relaxed max-w-[700px]">
          {testimonials[current].text}
        </p>

        <div className="mt-6">
          <h4 className="oswald text-[16px] font-semibold uppercase">
            {testimonials[current].name}
          </h4>
          <p className="inter text-[#000000] text-[14px] font-medium">
            {testimonials[current].role}
          </p>
        </div>
        </motion.div>
      {/* </div> */}
    </div>

    </div>
    <LetsGet />   
    <FollowUs />
    <Footer />
    </div>
  );
};

export default ThreeD;













// //// import React, { useEffect, useState } from "react";
// import { useState, useEffect, useCallback } from "react";
// import { motion } from "framer-motion";
// // import { BsArrowUpRightCircle } from "react-icons/bs";
// import { HiArrowLeft } from "react-icons/hi";
// import { HiArrowRight } from "react-icons/hi";
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';

//   const ThreeD = () => {
    
//   const [mouse, setMouse] = useState({ x: 0, y: 0 });

//   const handleMouseMove = (e) => {
//     const rect = e.currentTarget.getBoundingClientRect();
//     const x = (e.clientX - rect.left - rect.width / 2) / 40;
//     const y = (e.clientY - rect.top - rect.height / 2) / 40;
//     setMouse({ x, y });
//   };

//   const items = [
//     "WORK WITH US","WORK WITH US","WORK WITH US","WORK WITH US",
//     "WORK WITH US","WORK WITH US","WORK WITH US","WORK WITH US",
//   ];


//   const xStep = 160;  
//   const yStep = 28;    
//   const scaleStep = 0.03;
//   const rotateStep = -4;
//   const opacityStep = 0.1;

//   const cards = [
//       "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//       "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//       "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//       "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//       "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//       "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//       "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//   ];

//   const carouselImages = [
//     "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//     "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//     "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//     "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//     "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038=",
//     "https://media.istockphoto.com/id/1443245439/photo/business-meeting-businesswoman-woman-office-portrait-job-career-happy-businessman-teamwork.jpg?s=612x612&w=0&k=20&c=1ZR02c1UKfGdBCNWzzKlrwrVZuEiOqnAKcKF4V_t038="
//   ];

//   // const [current, setCurrent] = useState(0);
//   // const [disable, setDisable] = useState(false);

//   // const changeSlide = (index) => {
//   //   if (disable) return;
//   //   setDisable(true);

//   //   const newIndex = (index + carouselImages.length) % carouselImages.length;
//   //   setCurrent(newIndex);

//   //   setTimeout(() => setDisable(false), 800);
//   // };

//   // useEffect(() => {
//   //   const handleKey = (e) => {
//   //     if (e.key === "ArrowUp") changeSlide(current - 1);
//   //     if (e.key === "ArrowDown") changeSlide(current + 1);
//   //   };
//   //   window.addEventListener("keydown", handleKey);
//   //   return () => window.removeEventListener("keydown", handleKey);
//   // }, [current]);

//   // let yStart = 0;
//   // const swipe = (end) => {
//   //   const diff = yStart - end;
//   //   if (Math.abs(diff) > 50) {
//   //     diff > 0 ? changeSlide(current + 1) : changeSlide(current - 1);
//   //   }
//   // };
//   const [current, setCurrent] = useState(0);
// const [disable, setDisable] = useState(false);

// const changeSlide = useCallback(
//   (index) => {
//     if (disable) return;
//     setDisable(true);

//     const newIndex =
//       (index + carouselImages.length) % carouselImages.length;
//     setCurrent(newIndex);

//     setTimeout(() => setDisable(false), 800);
//   },
//   [disable, carouselImages.length]
// );

// useEffect(() => {
//   const handleKey = (e) => {
//     if (e.key === "ArrowUp") changeSlide(current - 1);
//     if (e.key === "ArrowDown") changeSlide(current + 1);
//   };

//   window.addEventListener("keydown", handleKey);
//   return () => window.removeEventListener("keydown", handleKey);
// }, [current, changeSlide]);

//   return (
//     <div>
//       <Header />
//     <div className="bg-white flex flex-col sm:px-10 lg:px-24 xl:px-32 2xl:px-40">
//       {/* Top Section */}
//       <div className="container mx-auto md:px-0 px-3
//           flex flex-col lg:flex-row justify-start h-full pt-20 lg:pt-8">

//         <div className="oswald w-full lg:w-1/2 font-semibold lg:mt-24 xl:mt-12 
//             text-[35px] sm:text-[52px] lg:text-[55px] xl:text-[75px]">
//           <h2 className="text-[#908583]">MEET PCA</h2>
//           <h1 className="text-[#000000] leading-tight">
//             WHERE&nbsp;ART&nbsp;MEETS<br />INNOVATION
//           </h1>
//         </div>

//         <div className="w-full sm:w-1/2 flex flex-col items-end mt-0 
//             lg:mt-28 xl:mt-20 sm:ml-[43vw] lg:ml-0 xl:ml-0">

//           <div className="relative xl:w-36 xl:h-36 w-28 h-28">
            
//             <div className=" absolute inset-0 rounded-full bg-[#ED772F]"></div>

//             <svg
//               viewBox="0 0 300 300"
//               className="absolute inset-0 w-full h-full"
//             >
//               <defs>
//                 <path
//                   id="circlePath"
//                   d="M 150, 150
//                     m -110, 0
//                     a 110,110 0 1,1 220,0
//                     a 110,110 0 1,1 -220,0"
//                 />
//               </defs>

//               <text
//                 fontSize="28"
//                 fontWeight="s00"
//                 fill="#000000"
//                 letterSpacing="4"
//               >
//                 <textPath
//                   href="#circlePath"
//                   startOffset="50%"
//                   textAnchor="middle"
//                   fontFamily="oswald"
//                 >
//                   OPEN - STUDIOS - 3D - VISUALIZATION -
//                 </textPath>
//               </text>
//             </svg>

//             <div className="absolute inset-0 flex items-center justify-center">
//               <img
//                 src="../assets/PCA_logo.png"
//                 alt="Logo"
//                 className="w-10 h-auto object-contain"
//               />
//             </div>
//           </div>

//           <div className="oswald mt-9 text-right font-medium xl:text-[28px] text-[20px]">
//             <h2 className="text-[#000000]">BASED IN RAJKOT, GUJARAT</h2>
//             <h2 className="text-[#908583]">WORKING WORLDWIDE</h2>
//           </div>

//         </div>
//       </div>

//       <hr className="border-t-2 border-[#908583] w-[97%] mx-auto mt-1" />

//       {/* Description */}
//       <div className="grid grid-cols-12 items-center py-7">
//         <div className="hidden sm:flex justify-center items-center text-[#908583] text-[18px] gap-3 col-span-1">
//             <span>↓</span>
//             <span>↓</span>
//             <span>↓</span>
//         </div>

//         <div className="bodyFont col-span-12 sm:col-span-11 flex justify-end text-left sm:text-right text-[#1A1919] text-[18px]">
//             <p className="xl:w-[850px] lg:w-[65%] sm:w-[65%] w-[90%]">
//                 At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
//                 As a team of passionate creatives, tech enthusiasts, and strategic thinkers,
//                 we are dedicated to transforming your vision into reality.
//             </p>
//         </div>
//       </div>

//       {/* Mobile */}
//       <div className="lg:hidden block">
//         <div
//           className="w-full min-h-screen flex items-center justify-center overflow-hidden px-4"
//           onWheel={(e) => {
//             e.preventDefault();
//             if (e.deltaY > 0) {
//               changeSlide(current + 1);
//             } else {
//               changeSlide(current - 1);
//             }
//           }}
//         >
//           <div className="flex w-full max-w-[1200px] h-[80vh] gap-16 justify-center items-center max-md:flex-col max-md:h-auto max-md:gap-6">
//             <div className="flex justify-center items-center flex-1">
//               <div className="relative w-full max-w-[500px] h-[70vh] flex flex-col items-center perspective-[1000px] max-md:h-[60vh] max-md:max-w-[350px]">

//                 <div className="relative w-[450px] h-full flex flex-col justify-center items-center transition-transform duration-[800ms] ease-custom transform-style-3d max-md:w-[350px]">
//                   {carouselImages.map((src, i) => {
//                     const offset = (i - current + carouselImages.length) % carouselImages.length;

//                     let cls =
//                       "absolute bg-white shadow-2xl overflow-hidden cursor-pointer transition-all duration-[800ms] ease-custom";
//                     let transform = "";
//                     let opacity = "opacity-0 pointer-events-none";
//                     let gray = "grayscale";

//                     if (offset === 0) {
//                       opacity = "opacity-100";
//                       gray = "";
//                       transform = "scale-[1.1] translate-z-[0px] z-10";
//                     } else if (offset === 1)
//                       transform =
//                         "translate-y-[150px] scale-[0.9] translate-z-[-100px] opacity-90 z-5";
//                     else if (offset === 2)
//                       transform =
//                         "translate-y-[300px] scale-[0.8] translate-z-[-300px] opacity-70 z-0";
//                     else if (offset === carouselImages.length - 1)
//                       transform =
//                         "translate-y-[-150px] scale-[0.9] translate-z-[-100px] opacity-90 z-5";
//                     else if (offset === carouselImages.length - 2)
//                       transform =
//                         "translate-y-[-300px] scale-[0.8] translate-z-[-300px] opacity-70 z-0";

//                     return (
//                       <div
//                         key={i}
//                         onClick={() => changeSlide(i)}
//                         className={`${cls} ${opacity} ${transform} w-[270px] h-[180px] sm:w-[320px] sm:h-[180px]`}
//                       >
//                         <img
//                           src={src}
//                           alt="img"
//                           className={`w-full h-full object-cover transition-all duration-[800ms] ease-custom ${gray}`}
//                         />
//                       </div>
//                     );
//                   })}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* desktop */}
//       <div
//         className="hidden lg:block px-10 py-10 mt-10
//                     mx-[calc(50%-49.5vw)] overflow-hidden"
//         onMouseMove={handleMouseMove}
//         onMouseLeave={() => setMouse({ x: 0, y: 0 })}
//       >
//         <div
//           className="relative h-[450px] flex justify-center items-start
//                     pl-10 mx-auto max-w-[1200px] lg:max-w-[1100px] xl:max-w-[1300px] 2xl:max-w-[1500px]"
//           style={{ perspective: "1600px" }}
//         >
//           {cards.map((src, i) => {
//             const zIndexValue = cards.length - i;

//             return (
//               <motion.div
//                 key={i}
//                 className="absolute w-[420px] h-[300px] overflow-hidden shadow-xl bg-white"
//                 style={{ zIndex: zIndexValue, left: 0 }}
//                 initial={{
//                   x: xStep * i,
//                   y: yStep * i,
//                   scale: 1 - i * scaleStep,
//                   rotateY: rotateStep * i,
//                   opacity: 1 - i * opacityStep,
//                 }}
//                 animate={{
//                   rotateX: mouse.y,
//                   rotateY: mouse.x + rotateStep * i,
//                 }}
//                 whileHover={{
//                   y: yStep * i - 20,
//                   scale: 1.15,
//                   rotateY: 0,
//                   rotateX: 0,
//                   zIndex: 9999,
//                   opacity: 1,
//                   boxShadow: "0 30px 50px rgba(0,0,0,0.25)"
//                 }}
//                 transition={{ type: "spring", stiffness: 120, damping: 16 }}
//               >
//                 <img src={src} className="w-full h-full object-cover" alt={`card-${i}`} />
//               </motion.div>
//             );
//           })}
//         </div>
//       </div>
        
//         <div className="w-full px-4 sm:px-8 lg:px-16 xl:px-20 py-5">
//           <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen gap-10">

//             <div className="relative h-[60vh] lg:h-screen overflow-hidden">
//               <img
//                 src="https://alienationtech.com/img/meeting.jpg"
//                 alt="Visualization Team"
//                 className="w-full h-[86vh] object-cover object-right"
//               />
//             </div>

//             <div className="flex flex-col justify-center h-full lg:pl-10 lg:border-l lg:border-[#908583]">

//               <div className="mb-10">
//                 <h2 className="oswald text-3xl sm:text-4xl xl:text-5xl font-extrabold leading-tight uppercase text-black">
//                   Pioneering the Future<br className="hidden xl:block"/>
//                   of 3D Architectural<br className="hidden xl:block"/>{" "}
//                   Visualization
//                 </h2>

//                 <p className="bodyFont text-sm sm:text-base text-[#1A1919] max-w-md mt-8">
//                   At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
//                   As a team of passionate creatives, tech enthusiasts, and strategic thinkers,
//                   we are dedicated to transforming your vision into reality.
//                 </p>
//               </div>

//               <div className="grid grid-cols-2 gap-4 mb-10">
//                 <div className="bg-[#F56E0F] rounded-md p-4 text-black">
//                   <h1 className="oswald text-[48px]">10+</h1>
//                   <p className="inter text-sm">Years of experience</p>
//                 </div>

//                 <div className="bg-[#F56E0F] rounded-md p-4 text-black">
//                   <h1 className="oswald text-[48px]">88+</h1>
//                   <p className="inter text-sm">Projects Completed</p>
//                 </div>

//                 <div className="bg-[#F56E0F] rounded-md p-4 text-black">
//                   <h1 className="oswald text-[48px]">5000+</h1>
//                   <p className="inter text-sm">Visualizations Created</p>
//                 </div>

//                 <div className="bg-[#F56E0F] rounded-md p-4 text-black">
//                   <h1 className="oswald text-[48px]">5</h1>
//                   <p className="inter text-sm">Industry Awards</p>
//                 </div>
//               </div>

//               <div className="pt-6 border-t border-[#908583]">
//                 <h2 className="oswald text-3xl sm:text-4xl font-semibold uppercase text-black">
//                   The Heart of PCA
//                 </h2>

//                 <p className="bodyFont text-sm sm:text-base text-[#1A1919] max-w-md mt-4">
//                   At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
//                   As a team of passionate creatives, tech enthusiasts, and strategic thinkers,
//                   we are dedicated to transforming your vision into reality.
//                 </p>
//               </div>

//             </div>
//           </div>
//         </div>

//         <hr className="border-0 lg:border-t lg:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-2" />

//         <div className="w-full text-center py-16 px-4 sm:px-8 md:px-20 lg:px-32">

//           <h3 className="oswald text-[20px] font-medium text-[#908583] uppercase">
//             Our Approach
//           </h3>

//           <h1 className="oswald text-black font-semibold uppercase leading-tight 2xl:text-[90px] xl:text-[70px] lg:text-[40px] sm:text-[35px] text-[20px]
//                 mt-3">
//                 Understanding&nbsp;Your&nbsp;Needs,<br />
//                 Delivering&nbsp;<span className="inline-block ml-3 xl:mb-7 align-middle">
//                   <img
//                     src="/assets/bulb.png" 
//                     alt="Idea Bulb"
//                     className="inline-block sm:w-auto w-[70px] sm:h-[55px] object-cover"
//                   />
//                 </span> <br />
//                 Superior&nbsp;Outcomes
//           </h1>

//           <p className="bodyFont text-[#1A1919] text-[18px] max-w-[750px] mx-auto mt-5 leading-relaxed">
//             At Open Studios, we believe that every great idea deserves the perfect platform to thrive. 
//             As a team of passionate creatives, tech enthusiasts, and strategic thinkers, 
//             we are dedicated to transforming your vision into reality.
//           </p>

//           <button className="inter mt-8 bg-[#F56E0F] text-[#1A1919] font-semibold px-6 py-3 rounded-full 
//           text-sm sm:text-base hover:bg-[#ed772f] transition-all duration-300 flex items-center mx-auto gap-2">
//             <span>●</span> LET'S TALK
//           </button>

//         </div>

//         <div className="w-screen overflow-hidden whitespace-nowrap py-4 mx-[calc(50%-51vw)]">
//         <h1 className="oswald marquee-track inline-flex items-center gap-6 font-bold text-[40px] tracking-wide text-black">
       
//         {[...items, ...items].map((text, idx) => (
//           <span key={idx} className="flex items-center gap-6">
//             {text} <img src="../assets/PCA_logo.png" className="w-10 inline-block" alt="img" />
//           </span>
//         ))}
//       </h1>
//       </div>
//       <style>
//         {`
//           .marquee-track {
//             width: max-content;
//             display: inline-flex;
//             animation: marqueeScroll 12s linear infinite;
//           }

//           // .marquee-track:hover {
//           //   animation-play-state: paused;
//           // }

//           .marquee-track span:hover {
//             transform: scale(1.1);
//             transition: transform 0.3s;
//           }

//           @keyframes marqueeScroll {
//             0% { transform: translateX(0); }
//             100% { transform: translateX(-50%); }
//           }

//           @media screen and (max-width: 768px) {
//             .marquee-track {
//               animation: marqueeScroll 20s linear infinite;
//             }
//             .marquee-track span img {
//               width: 40px;
//             }
//             .marquee-track {
//               font-size: 28px;
//             }
//           }
//         `}
//       </style>

//       <div className="bg-[#F4F1EF] px-4 sm:px-8 lg:px-32 py-10 mt-10 mx-[calc(50%-49.5vw)]">

//         <h3 className="oswald text-[20px] font-medium text-[#908583] uppercase text-center">
//             Our Values
//         </h3>

//         <h1 className="oswald text-3xl sm:text-4xl lg:text-5xl font-bold text-center text-[#000000] mb-12">
//           WHERE CREATIVITY MEETS<br />PRECISION AND CONNECTION
//         </h1>

//         <div className="flex justify-center mb-12">
//           <img
//             src="https://thumbs.dreamstime.com/b/group-young-business-people-working-as-team-communicating-corporate-office-full-concentration-work-417970352.jpg"
//             alt="Visualization Team"
//             className="h-[400px] w-auto object-cover"
//           />
//         </div>

//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-left mb-12 text-[#000000]">
//           <div>
//             <h2 className="oswald text-[30px] font-bold mb-2">CREATIVITY</h2>
//             <p className="text-[16px] inter">
//               We harness imaginative thinking to produce visually stunning and original 3D representations that captivate and inspire.
//             </p>
//           </div>
//           <div>
//             <h2 className="oswald text-[30px] font-bold mb-2">EXCELLENCE</h2>
//             <p className="text-[16px] inter">
//               We commit to the highest standards of quality and precision, ensuring every project meets our rigorous benchmarks of excellence.
//             </p>
//           </div>
//           <div>
//             <h2 className="oswald text-[30px] font-bold mb-2">ADAPTABILITY</h2>
//             <p className="text-[16px] inter">
//               We stay agile and responsive to evolving trends and client needs, constantly refining our approach to deliver cutting-edge results.
//             </p>
//           </div>
//           <div>
//             <h2 className="oswald text-[30px] font-bold mb-2">EMPATHY</h2>
//             <p className="text-[16px] inter">
//               We connect deeply with our clients and their audiences, crafting visuals that resonate with authenticity and emotional impact.
//             </p>
//           </div>
//         </div>

//         <hr className="border-0 sm:border-t sm:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-2" />

//         <div>   
//           <div className="flex flex-col lg:flex-row items-start justify-between gap-6 mt-8">
//             <h1 className="oswald text-3xl sm:text-4xl lg:text-5xl font-bold text-[#000000] lg:w-1/2">
//               CLIENTS
//             </h1>

//             <p className="text-[16px] inter lg:w-1/2">
//               At Open Studios, we believe that every great idea deserves the perfect platform to thrive.
//               As a team of passionate creatives, tech enthusiasts, and strategic thinkers, we are dedicated
//               to transforming your vision into reality.
//             </p>
//           </div>

//           <div className="w-auto overflow-hidden whitespace-nowrap py-10 mt-5">
//             <style>
//               {`
//                 .logo-slide {
//                   display: inline-flex;
//                   gap: 60px;
//                   animation: scrollLogos 12s linear infinite;
//                 }
//                 @keyframes scrollLogos {
//                   0% { transform: translateX(0); }
//                   100% { transform: translateX(-50%); }
//                 }
//               `}
//             </style>


//             <div className="logo-slide">
//               {[
//                 // "/assets/openV_logo1.png",
//                 // "/assets/openV_logo2.png",
//                 // "/assets/openV_logo3.png",
//                 // "/assets/openV_logo4.png",
//                 // "/assets/openV_logo5.png",
//                 // "/assets/openV_logo6.png",
//                 // "/assets/openV_logo1.png",
//                 // "/assets/openV_logo2.png",
//                 // "/assets/openV_logo3.png",
//                 // "/assets/openV_logo4.png",
//                 // "/assets/openV_logo5.png",
//                 // "/assets/openV_logo6.png",
//                 // "/assets/openV_logo1.png",
//                 // "/assets/openV_logo2.png",
//                 // "/assets/openV_logo3.png",
//                 // "/assets/openV_logo4.png",
//                 // "/assets/openV_logo5.png",
//                 // "/assets/openV_logo6.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//                 "/assets/openV_logo1.png",
//               ].map((src, i) => (
//                 <img
//                   key={i}
//                   src={src}
//                   alt="img"
//                   className="h-12 hover:scale-110 transition duration-300 ease-in-out"
//                 />
//               ))}
//             </div>
//           </div>
//         </div>

//         <hr className="border-0 sm:border-t sm:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-2" />

//         <div className="flex flex-col lg:flex-row items-start justify-between gap-6 mt-8">
  
//         <h1 className="oswald text-2xl sm:text-4xl lg:text-5xl font-bold text-[#000000] lg:w-1/2 uppercase">
//           Crafting Visualization <br /> for industry leaders
//         </h1>

//         <div className="flex flex-col lg:w-[300px] lg:border-l lg:border-[#908583] lg:mr-5 lg:px-5">
//           <p className="text-[16px] inter">
//             At Open Studios, we believe that every great idea deserves the perfect platform to thrive. 
//             As a team of passionate creatives, tech enthusiasts, and strategic thinkers, 
//             we are dedicated to transforming your vision into reality.
//           </p>

//           <button className="mt-6 bg-[#F56E0F] text-[#1A1919] font-semibold px-6 py-3 rounded-full inter
//             text-sm sm:text-base hover:bg-[#ed772f] transition-all duration-300 flex items-center w-fit gap-2">
//             OUR SOLUTIONS
//           </button>
//         </div>
//       </div>

//       <hr className="border-0 sm:border-t sm:border-[#908583] w-[100%]  mx-auto 2xl:mb-5 mt-5" />

//         <div className="flex flex-col lg:flex-row items-center justify-between gap-5 mt-10 mb-10 w-full xl:pl-12 pl-0">

//         <div className="lg:w-auto lg:border-r lg:border-[#908583] pr-0 lg:pr-12 order-2 lg:order-1 w-full">
//           <h2 className="oswald text-3xl sm:text-4xl lg:text-5xl font-bold text-[#000000] leading-snug lg:mb-20 mb-6 uppercase">
//             Elevate Your <br className="hidden lg:block"/>Designs with <br className="hidden sm:block"/>Stunning 3D <br className="hidden lg:block"/>Visualization
//           </h2>

//           <p className="text-[16px] inter text-[#000000] max-w-full lg:w-[300px]">
//             At Open Studios, we believe that every great idea deserves the perfect platform to thrive. As a team of 
//           </p>
//         </div>

//         <div className="flex justify-around lg:justify-around 2xl:justify-end w-full order-1 lg:order-2">
//           <img
//             src="https://thumbs.dreamstime.com/b/group-young-business-people-working-as-team-communicating-corporate-office-full-concentration-work-417970352.jpg"
//             alt="Creative Vision"
//             className="sm:h-[400px] w-auto object-cover shadow-lg"
//           />
//         </div>

//       </div>
//       </div>

//         <div className="flex flex-col lg:flex-row items-start justify-between gap-6 mt-16 px-4 sm:px-8 lg:px-14">

//           <h1 className="oswald text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#000000] uppercase lg:w-1/2 leading-tight">
//             Showcasing <br />Our Expertise
//           </h1>

//           <div className="flex flex-col lg:w-1/2 lg:px-6">
            
//             <p className="text-[16px] inter text-[#1A1919] xl:w-[600px]">
//               At Open Studios, we believe that every great idea deserves the perfect platform to thrive. As a team of passionate creatives, tech enthusiasts, and 
//             </p>

//             <button className="mt-6 bg-[#F56E0F] text-[#1A1919] font-semibold px-6 py-3 rounded-full inter
//               text-sm sm:text-base hover:bg-[#ed772f] transition-all duration-300 flex items-center w-fit gap-2 uppercase">
//               our work
//             </button>
//           </div>
//         </div>

//         <hr className="border-t-2 border-[#908583] w-[86%] sm:w-[85vw] lg:w-[75vw] xl:w-[80vw] 2xl:w-[85%] mx-auto mt-8" />

//         <div className="px-4 sm:px-8 lg:px-14 py-8 relative">

//           <div className="hidden lg:block absolute top-3 bottom-3 left-1/2 border-r border-[#908583]"></div>

//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 lg:gap-x-20 relative">

//             {/* Card 1 */}
//             <div className="w-full flex flex-col">
//               <div className="overflow-hidden">
//                 <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
//               </div>
//               <div className="pt-4 mt-4">
//                 <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
//                 <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">SERVICES</span>
//                     <p className="inter font-medium">Exterior + Interior</p>
//                   </div>
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">LOCATION</span>
//                     <p className="inter font-medium">Aspen, USA</p>
//                   </div>
//                 </div>
//               </div>
//               <hr className="hidden sm:block border-t border-[#908583] mt-6"/>
//             </div>

//             {/* Card 2 */}
//             <div className="w-full flex flex-col">
//               <div className="overflow-hidden">
//                 <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
//               </div>
//               <div className="pt-4 mt-4">
//                 <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
//                 <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">SERVICES</span>
//                     <p className="inter font-medium">Exterior + Interior</p>
//                   </div>
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">LOCATION</span>
//                     <p className="inter font-medium">Aspen, USA</p>
//                   </div>
//                 </div>
//               </div>
//               <hr className="hidden sm:block border-t border-[#908583] mt-6"/>
//             </div>

//             {/* Card 3 */}
//             <div className="w-full flex flex-col">
//               <div className="overflow-hidden">
//                 <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
//               </div>
//               <div className="pt-4 mt-4">
//                 <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
//                 <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">SERVICES</span>
//                     <p className="inter font-medium">Exterior + Interior</p>
//                   </div>
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">LOCATION</span>
//                     <p className="inter font-medium">Aspen, USA</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Card 4 */}
//             <div className="w-full flex flex-col">
//               <div className="overflow-hidden">
//                 <img src="https://img.freepik.com/premium-photo/nice-modern-house-near-lake_656932-2755.jpg?semt=ais_hybrid&w=740&q=80" alt="Eco Haven" className="w-auto h-auto object-cover transition duration-500" />
//               </div>
//               <div className="pt-4 mt-4">
//                 <h2 className="oswald text-2xl sm:text-3xl font-bold text-[#000]">ECO HAVEN</h2>
//                 <div className="mt-2 flex justify-between text-[14px] sm:text-[16px] text-[#1A1919] inter">
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">SERVICES</span>
//                     <p className="inter font-medium">Exterior + Interior</p>
//                   </div>
//                   <div>
//                     <span className="oswald text-[#908583] font-semibold">LOCATION</span>
//                     <p className="inter font-medium">Aspen, USA</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>

//         <hr className="border-t-2 border-[#908583] w-[86%] sm:w-[85vw] lg:w-[75vw] xl:w-[80vw] 2xl:w-[85%] mx-auto mb-5" />

//         <div className="bg-white w-full flex flex-col lg:flex-row justify-between items-center py-20 px-6 sm:px-12 lg:px-28">

//           <div className="flex flex-col justify-between h-full lg:w-1/3 sm:mr-40">
//             <h3 className="oswald text-[14px] sm:text-[16px] text-[#000000] uppercase">
//               Real Experiences   - Real Impact
//             </h3>

//             <div className="flex gap-3 mt-20">
//             <button
//               className="w-10 h-10 rounded-full bg-[#FAC79F] flex items-center justify-center text-white font-bold text-xl hover:opacity-90 cursor-pointer"
//             >
//               <HiArrowLeft />
//             </button>

//             <button
//               className="w-10 h-10 rounded-full bg-[#F27116] flex items-center justify-center text-white font-bold text-xl hover:opacity-90 cursor-pointer"
//             >
//               <HiArrowRight />
//             </button>
//           </div>

//           </div>

//           <div className="lg:w-2/3 mt-8 lg:mt-0 text-left ml-20">
//             <p className="bodyFont text-[#1A1919] text-[18px] leading-relaxed max-w-[700px]">
//               At Open Studios, we believe that every great idea deserves the perfect platform to thrive. As a team of
//               passionate creatives, tech enthusiasts, and strategic thinkers, we are dedicated to transforming your vision into reality.
//             </p>

//             <div className="mt-6">
//               <h4 className="oswald text-[16px] font-semibold uppercase">Mark Rodriguez</h4>
//               <p className="inter text-[#000000] text-[14px] font-medium">
//                 Real Estate Developer, Horizon Properties
//               </p>
//             </div>
//           </div>

//         </div>

//         <div className="relative w-[96%] lg:w-[98%] mx-auto bg-gradient-to-r from-[#F56E0F]/30 to-[#F56E0F]/50 py-16 px-4 sm:px-6 xl:px-12 lg:px-5 overflow-hidden rounded-3xl min-h-[300px] md:min-h-auto mb-20">
//             <div className="absolute top-1/2 left-0 -translate-y-1/2 -translate-x-1/2 w-[400px] h-[400px] bg-orange-600 rounded-full blur-3xl opacity-50 hidden md:block"></div>
//               <div className="hidden lg:block absolute bottom-0 left-10 lg:left-14 w-24 lg:w-auto">
//                 <img
//                   src="/assets/OpenLogo.png"
//                   alt="Decorative"
//                   className="w-[500px] h-full object-contain opacity-60 brightness-50" />
//               </div>
        
//                 <div className="flex flex-col lg:flex-row items-center justify-between gap-x-16">
//                 <div className="text-left z-10">
//                   <p className="bodyFont text-xl lg:text-2xl font-semibold leading-snug tracking-wide text-white 
//                                 text-left">Let’s Make Your Brand the One Everyone’s Talking About</p>
//                 </div>
//                 <div className="mt-8 lg:mt-0 z-10 flex justify-center w-full lg:w-auto">
//                   <div className="p-4 sm:p-5 md:p-6 w-[300px] sm:w-[320px] md:w-[350px] lg:w-[450px] xl:w-[550px] h-[160px] sm:h-[200px] md:h-[200px] lg:h-[180px] 
//                                bg-white/50 backdrop-blur-md rounded-3xl shadow-lg border border-white/30">
//                     <div className="p-4 sm:p-6 md:p-8 w-full h-full bg-white backdrop-blur-md rounded-3xl shadow-lg border border-white/20 flex items-center justify-center">
//                       {/* <button className="flex items-center rounded-full overflow-hidden group">
//                         <div className="bg-[#F56E0F] text-black font-medium px-3 sm:px-4 py-2 sm:py-3 rounded-full text-xs sm:text-sm transition-all duration-300 group-hover:bg-orange-300">
//                             Let’s Get Building
//                         </div>
//                         <div className="relative w-10 h-10 sm:w-10 sm:h-10 flex items-center justify-center">
//                           <span className="relative flex items-center justify-center w-10 h-10 rounded-full bg-[#F56E0F] text-black text-xl transition-colors duration-300 group-hover:bg-orange-300">
//                           <BsArrowUpRightCircle />
//                          </span>
//                          </div>
//                       </button> */}
//                       <div className='flex justify-center mt-[5%] lg:mt-[2%]'>
//                         <div className="joint_btn arrow_btn-wrapper bg-[#F56E0F] text-black font-medium bodyFont px-3 sm:px-4 py-2 sm:py-3 rounded-full text-xs sm:text-sm transition-all duration-300 group-hover:bg-orange-300">
//                           Let’s Get Building
//                         </div>
//                         <div style={{ '--clr': '#F56E0F' }} className="arrow_btn cursor-pointer">
//                             <span className="arrow_btn__icon-wrapper">
//                                 <svg width="10" className="arrow_btn__icon-svg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 15">
//                                     <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
//                                 </svg>
//                                 <svg className="arrow_btn__icon-svg arrow_btn__icon-svg--copy" xmlns="http://www.w3.org/2000/svg" width="10" fill="none" viewBox="0 0 14 15">
//                                     <path fill="currentColor" d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"></path>
//                                 </svg>
//                             </span>
//                       </div>
//                     </div>
//                     </div>
//                   </div>
//                 </div>
//              </div>
//           </div>
//     </div>
//     <Footer />
//     </div>
//   );
// };

// export default ThreeD;
